import { render, staticRenderFns } from "./ChildFull.vue?vue&type=template&id=73f86ac6"
import script from "./ChildFull.vue?vue&type=script&lang=js"
export * from "./ChildFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports